module.exports = __webpack_public_path__ + "static/2front-web-2-984f0079d09b50f5a2aad6912338e820.png";